"use strict"

// presicion is key stack
var digitsStack = {};
var disabled = false;

function initialize(precision) {
  if (precision) {
    if (!digitsStack[precision]) { digitsStack[precision] = {offset:0, allowIncrement:false, latestResult: -1}; }
  }

}

var onePromilleOfLastUsedDecimal = 0.0000001;

function getDigit(value, precision) {
  var number = (value+onePromilleOfLastUsedDecimal) / precision;
  return Math.round( (number | 0) - ((number / 10) | 0) * 10);
}

function isIncremented(prevVal, newVal, precision) {
  var prevDigit = getDigit(prevVal, precision);
  var newDigit = getDigit(newVal, precision);
  if (newDigit < prevDigit) {
    newDigit += 10;
  }
  var delta = newDigit - prevDigit;
  if (delta > 0 && delta < 5) {
    return true;
  } else {
    return false;
  }
}

// for unit test
module.exports.isIncremented = isIncremented;

module.exports.isIncrementAllowed = function(precision) {
  if (disabled) { return true }
  initialize(precision);
  return digitsStack[precision].allowIncrement;
}

module.exports.CheckAllowIncrement = function(precision, offset) {
  if (offset === null || offset === undefined) { offset = -1 }
  initialize(precision);
  if (offset < 0) {
    digitsStack[precision].allowIncrement = true;
    digitsStack[precision].offset = 0;
  } else {
    digitsStack[precision].offset += offset;
    if (digitsStack[precision].offset > 0.5) {
      digitsStack[precision].allowIncrement = true;
    }
  }
}

module.exports.clearAllowIncrement = function(precision) {
  initialize(precision);
  digitsStack[precision].allowIncrement = false;
  digitsStack[precision].offset = 0;
}

module.exports.clearAllowIncrementFlags = function(previousValue, newValue) {
  if (previousValue && newValue) {
    for (var precision in digitsStack) {
      if (isIncremented(previousValue, newValue, precision)) {
        digitsStack[precision].allowIncrement = false;
        digitsStack[precision].offset = 0;
      }
    }
  }
}

module.exports.setLatestResult = function(precision, value) {
  initialize(precision);
  digitsStack[precision].latestResult = value;
}

module.exports.getLatestResult = function(precision) {
  initialize(precision);
  return digitsStack[precision].latestResult;
}

module.exports.disable = function() {
  disabled = true;
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/digits-increment-checker.js
// module id = 294
// module chunks = 0